import { render, staticRenderFns } from "./RestrictionsInternalManagement.vue?vue&type=template&id=234265eb&scoped=true&"
import script from "./RestrictionsInternalManagement.vue?vue&type=script&lang=js&"
export * from "./RestrictionsInternalManagement.vue?vue&type=script&lang=js&"
import style0 from "./RestrictionsInternalManagement.vue?vue&type=style&index=0&id=234265eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234265eb",
  null
  
)

export default component.exports